import { Box, Card, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import CardSkeleton from '../../../shared/components/CardSkeleton';
import ServiceCard from './ServiceCard';

const ServicesList = ({ servicesList, isLoading }) => {
  const { t } = useTranslation();

  const showSkeleton = isLoading;

  return (
    <>
      <Box>
        {showSkeleton ? (
          <CardSkeleton />
        ) : servicesList?.length === 0 ? (
          <Card elevation={0} sx={{ p: 4, textAlign: "center", border: "1px dashed #E3E7EE" }}>
            <Typography color='text.secondary'>{t("adminDashboard.noServices")}</Typography>
          </Card>
        ) : (
          servicesList?.map((service, index) => (
            <Box key={service.id} mb={1}>
              <ServiceCard service={service} index={index} />
            </Box>
          ))
        )}
      </Box>
    </>
  );
}

export default ServicesList